import { MapPin } from 'lucide-react';

export interface PatientAvatarProps {
	firstName: string;
	lastName: string;
	middleInitial?: string;
	patientIdentifier?: number;
	visitAddress?: string;
}

export function PatientAvatar(props: PatientAvatarProps) {
	const middleInitial = props.middleInitial ? ` ${props.middleInitial}.` : '';
	return (
		<div className="flex flex-col justify-center gap-0.5">
			<p className="font-medium text-gray-900">
				{props.lastName}, {props.firstName}
				{middleInitial}
			</p>
			<div className="flex items-center gap-1 text-gray-500">
				<span className="min-w-[40px]  shrink-0 whitespace-nowrap"># {props.patientIdentifier}</span>
				<MapPin size={10} className="text-gray-300" />
				<span className="max-w-[140px] truncate">{props.visitAddress}</span>
			</div>
		</div>
	);
}
